// Newsletter
export const NEWSLETTER_SUBSCRIBE = 'NEWSLETTER_SUBSCRIBE';
export const NEWSLETTER_SUBSCRIBE_SUCCESS = 'NEWSLETTER_SUBSCRIBE_SUCCESS';
export const NEWSLETTER_SUBSCRIBE_ERROR = 'NEWSLETTER_SUBSCRIBE_ERROR';
export const PRODUCTREMIND = 'PRODUCTREMIND';
export const PRODUCTREMIND_SUCCESS = 'PRODUCTREMIND_SUCCESS';
export const PRODUCTREMIND_ERROR = 'PRODUCTREMIND_ERROR';
